import { Map } from 'immutable';

import * as types from './types';

const initialState = Map({
  loading: true,
  organization: Map(),
  pendingRequests: 0,
  settings: Map(),
});

const updateSettings = (state, payload) => (
  state.set('settings', state.get('settings').merge(Map(payload)))
);

const organizationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.DELETE_SAML_FILE.SUCCESS:
      return state.set('settings', initialState.get('settings'));
    case types.GET_SAML_SETTINGS.REQUEST:
      return state.withMutations((mutable) => {
        mutable.set('pendingRequests', mutable.get('pendingRequests') + 1);
        mutable.set('loading', true);
      });
    case types.GET_SAML_SETTINGS.FAILURE:
      return state.withMutations((mutable) => {
        const pendingRequests = mutable.get('pendingRequests') - 1;
        mutable.set('pendingRequests', pendingRequests);
        mutable.set('loading', pendingRequests > 0);
      });
    case types.GET_SAML_SETTINGS.SUCCESS:
      return state.withMutations((mutable) => {
        const pendingRequests = mutable.get('pendingRequests') - 1;
        mutable.set('pendingRequests', pendingRequests);
        mutable.set('loading', pendingRequests > 0);
        updateSettings(mutable, payload);
      });
    case types.GET_ORGANIZATION.REQUEST:
      return state.withMutations((mutable) => {
        mutable.set('pendingRequests', mutable.get('pendingRequests') + 1);
        mutable.set('loading', true);
      });
    case types.GET_ORGANIZATION.SUCCESS:
      return state.withMutations((mutable) => {
        const { settings, ...organization } = payload;
        const pendingRequests = mutable.get('pendingRequests') - 1;

        mutable.set('pendingRequests', pendingRequests)
          .set('loading', pendingRequests > 0)
          .set('organization', Map(organization));
        updateSettings(mutable, settings);
      });
    case types.UPDATE_SAML_SETTINGS.SUCCESS:
      return state.withMutations((mutable) => {
        updateSettings(mutable, payload);
      });
    case types.PATCH_US_SSO_SETTINGS.SUCCESS: {
      return state.withMutations((mutable) => {
        Object.entries(payload).forEach(([name, value]) => {
          mutable.setIn(['settings', name], value);
        });
      });
    }
    default:
      return state;
  }
};

export default organizationReducer;
